module.exports = __webpack_public_path__ + "lo-matching-banner-f0c36d97/LO_summary_Eng-e1a19a8c7cf527204099cd5b05920490.svg";